import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AsyncJobType } from '@recruitee/account-data';
import { AsyncJobActions } from '@recruitee/async-job-data';

import { GdprAutoConsentHttpClient } from './gdpr-auto-consent-http-client';
import { GdprAutoConsentActions } from './gdpr-auto-consent.store';

@Injectable({ providedIn: 'root' })
export class GdprAutoConsentEffects {
  public candidatesCounters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GdprAutoConsentActions.loadCandidateCount),
      mergeMap(() =>
        this.gdprAutoConsentHttpClient.loadCandidateCount().pipe(
          switchMap(data => [
            GdprAutoConsentActions.loadCandidateCountSuccess({
              payload: data,
            }),
          ]),
          catchError(error =>
            of(
              GdprAutoConsentActions.loadCandidateCountFailed({
                payload: { error },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public autoConsent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GdprAutoConsentActions.schedule),
      mergeMap(() =>
        this.gdprAutoConsentHttpClient.schedule().pipe(
          switchMap(({ uuid }) => [
            AsyncJobActions.create({
              payload: { job: { uuid, type: AsyncJobType.AutoConsentCandidatesEmail } },
            }),
            GdprAutoConsentActions.scheduleSuccess({
              payload: { uuid },
            }),
          ]),
          catchError(error =>
            of(
              GdprAutoConsentActions.scheduleFailed({
                payload: { error },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private gdprAutoConsentHttpClient: GdprAutoConsentHttpClient,
  ) {}
}
